<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="row mb-3">
                <div class="col-sm-auto">
                    <h1 class="content-title">{{ titleItem }}</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <MaterialInput
                        :readonly="readonly"
                        :disabled="readonly"
                        class="city-form-group city-bg"
                        id="input-channel"
                        name="channel"
                        :value="channelText">
                        <template #grpAppend>
                            <div class="d-flex align-items-center px-2">
                                <i :class="icon"></i>
                            </div>
                        </template>
                        {{ $t(`${pageID}.model.channel`) }}
                    </MaterialInput>
                </div>
                <div class="col-sm-4">
                    <MaterialInput
                        :readonly="readonly"
                        :disabled="readonly"
                        class="city-form-group city-bg"
                        id="input-module"
                        name="module"
                        :value="moduleName">
                        {{ $t(`${pageID}.model.module`) }}
                    </MaterialInput>
                </div>
                <div class="col-sm-4">
                    <MaterialDatePicker
                        :disabled="readonly"
                        class="city-form-group city-bg"
                        id="input-created_at"
                        name="created_at"
                        :value="createdAt"
                        :dateFormat="dateFormat">
                        {{ $t(`${pageID}.model.created_at`) }}
                    </MaterialDatePicker>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-sm-12">
                    <MaterialInput
                        :readonly="readonly"
                        :disabled="readonly"
                        class="city-form-group city-bg"
                        id="input-to"
                        name="to"
                        :value="to">
                        {{ $t(`${pageID}.model.to`) }}
                    </MaterialInput>
                </div>
                <div class="col-sm-6" v-if="isEmail">
                    <MaterialInput
                        :readonly="readonly"
                        :disabled="readonly"
                        class="city-form-group city-bg"
                        id="input-cc"
                        name="cc"
                        :value="cc">
                        {{ $t(`${pageID}.model.cc`) }}
                    </MaterialInput>
                </div>
                <div class="col-sm-6" v-if="isEmail">
                    <MaterialInput
                        :readonly="readonly"
                        :disabled="readonly"
                        class="city-form-group city-bg"
                        id="input-bcc"
                        name="bcc"
                        :value="bcc">
                        {{ $t(`${pageID}.model.bcc`) }}
                    </MaterialInput>
                </div>
                <div class="col-sm-12" v-if="isEmail">
                    <MaterialInput
                        :readonly="readonly"
                        :disabled="readonly"
                        class="city-form-group city-bg"
                        id="input-subject"
                        name="subject"
                        :value="subject">
                        {{ $t(`${pageID}.model.subject`) }}
                    </MaterialInput>
                </div>
                <div class="col-sm-12">
                    <div class="form-group city-form-group city-bg">
                        <label class="city-label active">{{ $t(`${pageID}.model.message`) }}</label>
                        <div class="form-control city-container" readonly="readonly" v-html="message"></div>
                    </div>
                </div>

            </div>

            <div class="row">
                <div class="col-12">
                    <buttons-footer
                        :enableButtons="!readonly"
                        @cancel="handleBack">
                    </buttons-footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationHistoryMixin from '../mixins/NotificationHistoryMixin'
import { capitalizeFirstLetter } from "@config/utils";

export default {
    mixins: [
        NotificationHistoryMixin
    ],
    components: {
        MaterialDatePicker: () => import(/* webpackChunkName: "datepicker" */ '@/components/form/MaterialDatePicker'),
    },
    props: {
        title: {
            type: String,
            default: null,
        },
        value: {
            type: Object,
            default: () => {},
        },
        dateFormat: {
            type: String,
            default: 'YYYY-MM-DD HH:mm:ss',
        },
    },
    data() {
        return {
            pageID: this.panelId,
            form: this.value,
        }
    },
    computed: {
        titleItem() {
            return this.$t(this.title ?? `${this.pageID}.title`);
        },
        moduleName() {
            return this.form?.module;
        },
        channel() {
            return this.form?.channel;
        },
        channelText() {
            return capitalizeFirstLetter(this.channel);
        },
        icon() {
            return this.channel in this.icons ? this.icons[this.channel] : this.icons['default'];
        },
        createdAt() {
            return this.form?.created_at;
        },
        payload() {
            return this.form?.data ?? {};
        },
        name() {
            return this.payload?.name;
        },
        to() {
            return this.payload?.recipients;
        },
        cc() {
            return this.payload?.cc;
        },
        bcc() {
            return this.payload?.bcc;
        },
        subject() {
            return this.payload?.subject;
        },
        message() {
            return this.payload?.content;
        },
        isEmail() {
            return this.channel ? this.channel.toLowerCase() == 'mail' : false;
        },
        isSms() {
            return this.channel ? this.channel.toLowerCase() == 'sms' : false;
        }
    },
    methods: {
    }
}
</script>
